import { service } from '../../../../helpers/http'

export const ActionGetTeacherIndicators = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTeacherIndicator',
        action: 'getTeacherIndicators',
        payload: payload
    })
}

export const ActionPostTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'postTeacherIndicator',
        payload: payload
    })
    
}

export const ActionPutTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'putTeacherIndicator',
        payload: payload
    })
    
}

export const ActionDeleteTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'deleteTeacherIndicator',
        payload: payload
    })
    
}

export const ActionIndexVariationStatuses = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTeacherIndicator',
        action: 'indexVariationStatuses',
        payload: payload
    })
}
